// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"125":"3f0e392e","497":"9c659a26","578":"f6e7e2bd","641":"cf2c2b53","705":"1aa5c1b7","778":"649ac5a2","884":"0f168591"}[chunkId] + ".chunk.js";
};